<template>

  <tbody>

  <tr v-for="item in items">

    <td>

      <a
              :href="getItemLink(item)"
              class="cart__link-image"
      >
        <img
                :src="item.attributes.image"
                :alt="item.name"
                class="cart__img-item img-fluid"
        >
      </a>


      <div>
        <a
                :href="getItemLink(item)"
                class="cart__link-name"
        >
          {{item.name}}
        </a>

        <a
                href="#"
                @click="removeItem(item)"
                class="cart__btn-remove-item"
        >
          Remover
        </a>

      </div>
    </td>

    <td>

      <input
              type="number"
              @input="updateItemQuantity({itemId: item.id, quantity: $event.target.value})"
              :value="item.quantity"
              pattern="[0-9]*"
              min="1"
              class="cart__input-quantity"
      >

    </td>

  </tr>

  </tbody>

</template>

<script>

  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';

  export default {

    name: "Items",

    methods: {

      // ...mapMutations('cart', {
      //   removeItem: types.REMOVE_ITEM,
      // }),

      ...mapActions('cart', [
        'removeItem', 'updateItemQuantity'
      ]),

      getItemLink(item) {
        return '/produto/' + item.attributes.slug;
      }

    },

    computed: {

      ...mapState('cart', {

        items: (state) => state.items,

      }),

    },


  }
</script>
